export function findPaymentMethodFromFluxAddCard(setPaymentMethodInfo, cardList) {
    const cardInfo = cardList.filter((card) => card.cardId ===  setPaymentMethodInfo.cardId);
    if(Object.keys(cardInfo).length === 0) {
        return {}
    } else{
        return  {
            value: cardInfo[0].cardId,
            mark: cardInfo[0].card.mark,
            type: cardInfo[0].card.type,
            lastDigits: cardInfo[0].card.lastDigits,
            update: false
        }
    }
}